module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.entry) ? _c('div', {
    staticClass: "details-container"
  }, [_c('div', {
    staticClass: "details-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.entry.name || ''))]), _vm._v(" "), _c('h2', [_vm._v("By " + _vm._s(_vm.entry.user && _vm.entry.user.name ? _vm.entry.user.name : 'unknown'))])]), _vm._v(" "), _c('div', {
    staticClass: "details row center-xs left-md"
  }, [_c('div', {
    staticClass: "details-menu col-xs-12 col-sm-12 col-md-12 col-lg-3 last-xs last-sm last-md"
  }, [_c('div', {
    staticClass: "row center-xs"
  }, [(_vm.entry && _vm.entry.description) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 first-xs first-sm first-md last-lg"
  }, [_c('div', {
    staticClass: "content description"
  }, [_c('h3', [_vm._v("Description")]), _vm._v("\n              " + _vm._s(_vm.entry.description || '') + "\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.$route.params.detailId) ? _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 first-xs first-sm first-md last-lg"
  }, [_c('div', {
    staticClass: "content description"
  }, [_c('h3', [_vm._v("Discussion")]), _vm._v(" "), _c('vue-disqus', {
    attrs: {
      "title": _vm.entry && _vm.entry.name ? _vm.entry.name : '',
      "shortname": "nadespots",
      "identifier": _vm.$route.params.detailId
    }
  })], 1)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "details-content col-xs-12 col-sm-12 col-md-12 col-lg-9 last-lg"
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.entry && _vm.entry.video && _vm.entry.video.videoId) ? _c('player', {
    attrs: {
      "id": _vm.entry.video.videoId,
      "start": _vm.entry.video.start,
      "end": _vm.entry.video.end
    }
  }) : _vm._e()], 1)])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-382fca68","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/scenes/Dashboard/Details/index.vue
// module id = 710
// module chunks = 1